import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ['menu']

  connect () {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)

    // Close the dropdown before Turbo snapshots/renders the page, so a cached
    // preview never flashes the menu open on the next navigation.
    this.closeOnNavigate = this.close.bind(this)
    document.addEventListener('turbo:before-cache', this.closeOnNavigate)
    document.addEventListener('turbo:before-render', this.closeOnNavigate)
  }

  toggle (event) {
    event.preventDefault()

    if (this.menuTarget.classList.contains('hidden')) {
      this.open()
    } else {
      this.close()
    }
  }

  open () {
    this.menuTarget.classList.remove('hidden')
    document.addEventListener('click', this.closeOnClickOutside)
  }

  close () {
    this.menuTarget.classList.add('hidden')
    document.removeEventListener('click', this.closeOnClickOutside)
  }

  closeOnClickOutside (event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  disconnect () {
    document.removeEventListener('click', this.closeOnClickOutside)
    document.removeEventListener('turbo:before-cache', this.closeOnNavigate)
    document.removeEventListener('turbo:before-render', this.closeOnNavigate)
  }
}
